import * as React from "react";
const SvgFiRrComet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comet_svg__a)">
      <path
        fill="#062147"
        d="M8.5 24a8.45 8.45 0 0 1-6.01-2.49c-6.344-6.556.65-16.6 6.651-20.11a2.51 2.51 0 0 1 2.556-.092 2.5 2.5 0 0 1 1.304 2.196v.729c.443-.273.913-.568 1.395-.87C16.472 2.062 18.62.717 19.912.21a2.95 2.95 0 0 1 3.206.673 2.95 2.95 0 0 1 .673 3.206c-.506 1.292-1.852 3.438-3.152 5.516-.302.48-.597.95-.87 1.395h.73a2.504 2.504 0 0 1 2.103 3.86C19.76 19.28 14.564 24 8.501 24zm1.992-21a.5.5 0 0 0-.27.082C5.174 6.134-1.308 14.396 3.903 20.097c5.703 5.21 13.96-1.27 17.014-6.32a.5.5 0 0 0 .02-.515.49.49 0 0 0-.44-.262H18c-.745.023-1.257-.862-.868-1.497.478-.834 1.125-1.866 1.811-2.96 1.193-1.905 2.547-4.064 2.984-5.183a.97.97 0 0 0-.225-1.062c-.108-.107-.505-.444-1.062-.226-1.118.438-3.277 1.792-5.183 2.985-1.094.686-2.126 1.333-2.96 1.81A1 1 0 0 1 11.001 6V3.506a.49.49 0 0 0-.262-.441.54.54 0 0 0-.246-.063zM9 19c-5.275-.138-5.274-7.863 0-8 5.275.138 5.273 7.863 0 8m0-6c-2.628.047-2.628 3.953 0 4 2.628-.047 2.628-3.953 0-4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrComet;
